<template>
    <div>
        <div class="container-fluid-grid" v-if="$appUtils.isDesktop()">
            <div class="row">
                <div class="col-12">
                    <table class="table table-bordered table-hover table-striped table-sm">
                        <thead class="thead-dark thead-center">
                        <tr>
                            <th>Nome</th>
                            <th style="width: 100px">Aniversário</th>
                            <th style="width: 300px">E-mail</th>
                            <th>Telefone(s)</th>
                            <th>Setor</th>
                            <th>Skype</th>
                            <th>Observações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(c,idx) in entity.customer_contacts_attributes" :key="c.id" class="line-item">
                            <td class="ellipsis c-p" @click="showModal(c)">{{c.name}}</td>
                            <td class="t-c c-p" @click="showModal(c)"><span v-if="c.day_month">{{c.day_month}}</span>
                            </td>
                            <td class="ellipsis"><a :href="`mailto:${c.email}`" class="link-theme" :title="c.email"
                                                    target="_blank">{{c.email | changeCase}}</a></td>
                            <td>
                                <div class="phone-container">
                                    <a v-if="c.phone1" :href="`tel:${c.phone1}`" class="link-theme" target="_blank">{{c.phone1
                                        | formatPhone}}</a>
                                    <a v-if="c.phone2" :href="`tel:${c.phone2}`" class="link-theme" target="_blank">{{c.phone2
                                        | formatPhone}}</a>
                                    <a v-if="c.phone3" :href="`tel:${c.phone3}`" class="link-theme" target="_blank">{{c.phone3
                                        | formatPhone}}</a>
                                </div>
                            </td>
                            <td class="ellipsis c-p" @click="showModal(c)">{{c.business_area}}</td>
                            <td class="ellipsis c-p" @click="showModal(c)">{{c.skype}}</td>
                            <td class="ellipsis c-p p-r o-x-h">
                                {{c.notes}}
                                <div class="actions btn-group btn-group-xs">
                                    <button type="button"
                                            class="btn btn-danger btn-xs"
                                            title="Remover"
                                            @click="destroy(idx)">
                                        <svg-icon icon="trash-alt"/>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="grid-mobile" v-for="(c,idx) in entity.customer_contacts_attributes" :key="c.id">
            <span class="nm ellipsis">{{c.name}}</span>
            <span class="email">
                    <span class="label">E-mail</span>
                    <a :href="`mailto:${c.email}`" class="link-theme" :title="c.email" target="_blank">{{c.email | changeCase}}</a>
                </span>
            <span class="birth" v-if="c.day_month">
                    <span class="label">Mês/Ano Niver</span>
                    {{c.day_month}}
                </span>
            <span class="phone1" v-if="c.phone1">
                    <span class="label">Tel 1</span>
                    <a v-if="c.phone1" :href="`tel:${c.phone1}`" class="link-theme" target="_blank">{{c.phone1 | formatPhone}}</a>
                </span>

            <span class="phone2" v-if="c.phone2">
                    <span class="label">Tel 2</span>
                    <a v-if="c.phone2" :href="`tel:${c.phone2}`" class="link-theme" target="_blank">{{c.phone2 | formatPhone}}</a>
                </span>

            <span class="phone3" v-if="c.phone3">
                    <span class="label">Tel 3</span>
                    <a v-if="c.phone3" :href="`tel:${c.phone3}`" class="link-theme" target="_blank">{{c.phone3 | formatPhone}}</a>
                </span>

            <div class="b" v-if="c.business_area && c.skype">
                <span class="ellipsis"><span class="label">Área</span>{{c.business_area}}</span>
                <span class="ellipsis"><span class="label">Skype</span>{{c.skype}}</span>
            </div>
            <div class="notes" v-if="c.notes">
                <span class="label">Observações</span>
                {{c.notes}}
            </div>
            <div class="act">
                <button type="button"
                        class="btn btn-sm"
                        title="Editar"
                        @click="showModal(c)">
                    <svg-icon icon="pencil-alt"/>
                </button>
                <button type="button"
                        class="btn btn-sm"
                        title="Remover"
                        @click="destroy(idx)">
                    <svg-icon icon="trash-alt"/>
                </button>
            </div>
        </div>

        <div class="t-r">
            <button type="button"
                    style="margin-right: 10px"
                    class="btn btn-sm btn-outline-primary"
                    @click="showModal">
                <svg-icon icon="plus"/>
                Adicionar
            </button>
        </div>
    </div>
</template>
<script>
    import {EventBus} from "../../utils/EventBus"
    import dayjs from 'dayjs'
    import {createNamespacedHelpers} from 'vuex'

    const {mapActions} = createNamespacedHelpers('customers');

    export default {
        name: "ContactsTab",
        props: {
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                year: dayjs().format('YYYY')
            }
        },
        methods: {
            ...mapActions(['destroyContact']),
            showModal(contact = {}) {
                if (this.entity.id > 0 && !contact.customer_id) contact = {...contact, customer_id: this.entity.id};

                EventBus.showContact(result => {
                    const idx = this.entity.customer_contacts_attributes.indexById({id: result.id});
                    if (idx > -1) {
                        this.$set(this.entity.customer_contacts_attributes, idx, result);
                    } else {
                        if (this.entity.id > 0) result.customer_id = this.entity.id;
                        this.entity.customer_contacts_attributes.push(result);
                    }

                    this.$emit('onUpdateTabBadges', result);
                }, {entity: contact, mode: 'edit'});
            },
            destroy(idx) {
                this.$store.commit('addModal', {
                    title: this.$t('common.destroyItemTitle'),
                    size: 'small',
                    body: this.$t('common.destroyItemMessage'),
                    buttons: [{
                        type: 'ok', class: 'btn btn-danger btn-sm',
                        method: id => {
                            this.$store.commit('destroyModal', id);
                            const contact = this.entity.customer_contacts_attributes[idx];

                            if (contact.id) {
                                this.destroyContact(contact.id)
                                    .then(() => {
                                        this.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name);
                                        this.$delete(this.entity.customer_contacts_attributes, idx);
                                    })
                                    .catch(err => {
                                        this.$appUtils.vibrate();
                                        this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar remover o contato...'}), this.$appStorage.getUser().name);
                                        console.error(err);
                                    })

                            } else {
                                this.$delete(this.entity.customer_contacts_attributes, idx);
                            }

                            this.$emit('onUpdateTabBadges', {});
                        }
                    }, {
                        type: 'close', label: 'Não', focus: true, method: id => this.$store.commit('destroyModal', id)
                    }]
                });
            }
        }
    }
</script>
<style scoped lang="scss">
    .grid-mobile {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-areas: 'nm nm nm' 'email email birth' 'phone1 phone2 phone3' 'b b b' 'notes notes notes' 'act act act';
        grid-template-rows: auto;
        grid-gap: 5px;
        padding: 5px;
        font-size: .8em;

        .label {
            display: block;
            text-align: center;
            font-weight: bold;
            font-size: .8em;
        }

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .nm {
            grid-area: nm;
            text-align: center;
        }

        .email {
            grid-area: email
        }

        .birth {
            grid-area: birth;
            text-align: right;
        }

        .phone1 {
            grid-area: phone1;
        }

        .phone2 {
            grid-area: phone2;
            text-align: center;
        }

        .phone3 {
            grid-area: phone3;
            text-align: right;
        }

        .b {
            grid-area: b;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                text-align: center;
            }
        }

        .notes {
            grid-area: notes
        }

        .act {
            grid-area: act;
            text-align: right;

            .btn {
                background-color: #e5e5e5;

                svg {
                    color: #000;
                }
            }

            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
</style>
